module.exports = __webpack_public_path__ + "img/78.4a73eae1.gif";